// extracted by mini-css-extract-plugin
export default {"card":"AntiWebhook_card__4F-hP","feature":"AntiWebhook_feature__4EFXz"};